module.exports = __webpack_public_path__ + "static/media/icone-pdf-azul.19648b4d.svg";